// extracted by mini-css-extract-plugin
export default {"startingPrice":"startingPrice__14sky","priceFrom":"priceFrom__o5f3e","price":"price__2n6wM"};
    if(module.hot) {
      // 1788784386139
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  